// Sepet Bölme penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.splitCart';

export const salesSplitCartGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'Sepet nasıl bölünür?'),
  intro: t(`${G}.intro`, 'Bir hesabı iki ayrı sepete ayırıp her birini ayrı ödemeyle kapatırsınız (ör. aynı masada ayrı ödeyen müşteriler). Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    list: t(`${G}.regions.list`, 'SEPET 1'),
    form: t(`${G}.regions.form`, 'SEPET 2'),
    footer: t(`${G}.regions.footer`, 'Birleştir / Kapat'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Soldaki SEPET 1 mevcut sepetinizdir, sağdaki SEPET 2 ayrı ödenecek kısımdır. Her sepetin fiş numarası kendi başlığındaki etikette görünür; Sepet 2, ana fiş numarasının sonuna -B2, -B3… eklenerek numaralanır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Restoran modunda bölme hemen kaydedilir; masa başka bir ekrandan açılsa da bölünmüş görünür.'),
        t(`${G}.s1.tip2`, 'Hızlı satışta bölme, ödeme alınana kadar yalnız bu ekranda tutulur.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Ürünleri taşıyın'),
      text: t(`${G}.s2.text`, 'Ürünün yanındaki büyük ok ("Tümünü taşı") ürünün tamamını karşı sepete geçirir. Adedi 1\'den fazla olan üründe kutuya adet yazıp küçük okla yalnız o kadarını taşıyın. Sepet 2\'deki ürünleri aynı şekilde geri taşıyabilirsiniz.'),
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Toplamları kontrol edin'),
      text: t(`${G}.s3.text`, 'Her sepetin altında Ara Toplam, varsa İndirim ve TOPLAM ayrı ayrı hesaplanır.'),
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Her sepeti ayrı ödeyin'),
      text: t(`${G}.s4.text`, 'Sepetin altındaki NAKİT, POS veya PARÇALI düğmesiyle yalnız o sepetin ödemesini alın; her ödeme ayrı bir satış olarak kaydedilir. Sepet 1 ödenince Sepet 2\'deki ürünler Sepet 1\'e geçer. Sepet 2 ödenince sonraki bölme yeni bir fiş numarasıyla (-B3…) başlar.'),
      tips: [
        t(`${G}.s4.tip1`, 'PARÇALI, ödemeyi birkaç ödeme tipine bölmek için parçalı ödeme penceresini açar; sepet o ödeme tamamlanınca boşalır.'),
        t(`${G}.s4.tip2`, 'Restoran modunda iki sepet de ödendiğinde pencere kapanır ve masalar ekranına dönülür.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Birleştirin veya kapatın'),
      text: t(`${G}.s5.text`, '"Sepetleri Birleştir ve Kapat" Sepet 2\'yi Sepet 1\'e geri ekler ve bölmeyi kaldırır. "Kapat" bölmeyi koruyarak pencereyi kapatır: Sepet 1 ana sepete yazılır, Sepet 2 pencereyi yeniden açtığınızda yerinde durur. Sağ üstteki (i) bu rehberi yeniden açar.'),
    },
  ],
});
